import { createEntityAdapter } from '@ngrx/entity';
import { GenesysCloudUser } from '../models/user.model';

export const userEntityAdapter = createEntityAdapter<GenesysCloudUser>({
  selectId: user => user.id
});
